export const styles = {
  root: {
  },
  text: {
    fontWeight: "bold",
  }
};
